module.exports = __webpack_public_path__ + "img/success-icon.71983f45.svg";